import React from 'react';
import { Image } from './Image';
import { Video } from './Video';
import { File } from './file';
import { PDF } from './PDF';
export const Attachment = ({ name, size, type, url, height, variant }) => {
    if (type.startsWith('image'))
        return React.createElement(Image, { variant: variant, name: name, src: url, height: height });
    else if (type.startsWith('video'))
        return React.createElement(Video, { name: name, height: height });
    else if (type === 'application/pdf')
        return React.createElement(PDF, { name: name, height: height });
    else
        return React.createElement(File, { name: name, height: height });
};
